import { Avatar, Button, Popconfirm, Switch } from "antd";
import type { ColumnsType } from "antd/es/table";
import { UserOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { FormConfigType } from "../../../components/editForm";
import { langPage, langCommon, langTableColumns } from "../../../locales";
import { MemberServer } from "../../../server";

const server = MemberServer.Manager
const lang = langPage?.member?.manager;

export const DEFAULT_QUERY_DATA = {
    Username: "",
    Type: null,
}

export const generateQueryFormConfig = (props: any): FormConfigType => {

    return [
        {
            title: lang?.username,
            type: "input",
            field: "Username",
            allowClear: true,
        },
    ];
}

export const generateTableColumns = (props: any): ColumnsType => {
    const { operationRef, loading, deleteData, setLoading, refresh } = props;

    return [
        {
            title: lang?.avatar,
            dataIndex: "Avatar",
            render(value, record, index) {
                return <Avatar src={value} icon={<UserOutlined />} />
            },
        },
        {
            title: lang?.username,
            dataIndex: "Username",
        },
        {
            title: lang?.inviteCode,
            dataIndex: "InviteCode",
        },
        {
            title: lang?.role,
            dataIndex: "RoleInfo",
            render(value, record, index) {
                return value?.Name
            },
        },
        {
            title: '类型',
            dataIndex: "Type",
            render(value, record, index) {
                return value === 1 ? lang?.role1 : lang?.role2
            },
        },
        {
            title: langCommon?.status,
            dataIndex: "Status",
            render: (_: any, row: any) => {
                return <Switch
                    checkedChildren={langCommon?.enabled}
                    unCheckedChildren={langCommon?.disable}
                    checked={row.Status === 1}
                    onChange={async (checked) => {
                        setLoading(true);
                        try {
                            const { Id, Role, Username } = row;
                            await server.enabled({ Id, Role, Username, Status: checked })
                            refresh();
                        } catch (error) {
                        }
                        setLoading(false);
                    }}
                />;
            }
        },
        // {
        //     title: langTableColumns?.lastIp,
        //     dataIndex: "LastIp",
        // },
        {
            title: langTableColumns?.lastTime,
            dataIndex: "LastTime",
            render: (val) => {
                return val ? dayjs.unix(val).format('YYYY-MM-DD HH:mm:ss') : '-'
            }
        },
        {
            title: langTableColumns?.CreatedAtString,
            dataIndex: "CreatedAt",
            render: (val) => {
                return val ? dayjs.unix(val).format('YYYY-MM-DD HH:mm:ss') : '-'
            }
        },
        {
            title: langTableColumns?.operation,
            dataIndex: "ops",
            width: 210,
            fixed: "right",
            render: (_: any, row: any) => {
                return (
                    <div>
                        <Button size="small" type="link"
                            onClick={() => operationRef?.current?.changeVisible(row, 'modify')}
                        >{langCommon?.modify}</Button>
                        <Button size="small" type="link"
                            onClick={() => operationRef?.current?.changeVisible({
                                Id: row.Id,
                                Password: null,
                            }, 'pwd')}
                        >{lang?.pwd}</Button>
                        <Popconfirm title={langCommon?.deleteItem} onConfirm={() => deleteData?.({ Id: row.Id })} >
                            <Button size="small" type="link" loading={loading} className="pdl0 pdr0">{langCommon?.delete}</Button>
                        </Popconfirm>
                    </div>
                )
            }
        }
    ]
}


export const DEFAULT_OPERATION_DATA = {
    Password: null,
    RoleId: null,
    Status: 1,
    Username: "",
    Type: null,
    Id: null
};

export const generateOperationFormConfig = (props: any): FormConfigType | any => {
    const { mode, roleOptions } = props;
    return mode === 'pwd' ? [
        {
            title: lang?.password,
            type: "input",
            extendType: 'Password',
            field: "Password",
            allowClear: true,
            rules: [{
                required: true,
                validator: async (rule: any, value: any) => {
                    if (!value) {
                        return Promise.reject(`${langCommon?.pleaseInput} ${lang?.password}`);
                    } else if (value.length < 6) {
                        return Promise.reject(`密码长度不能小于6位`);
                    }
                    return Promise.resolve();
                }
            }]
        },
    ] : [
        {
            title: lang?.username,
            type: "input",
            field: "Username",
            allowClear: true,
            rules: [{
                required: true,
                message: `${langCommon?.pleaseInput} ${lang?.username}`
            }]
        },
        ...(mode === 'create' ? [
            {
                title: lang?.password,
                type: "input",
                extendType: 'Password',
                field: "Password",
                allowClear: true,
                rules: [{
                    required: true,
                    validator: async (rule: any, value: any) => {
                        if (!value) {
                            return Promise.reject(`${langCommon?.pleaseInput} ${lang?.password}`);
                        } else if (value.length < 6) {
                            return Promise.reject(`密码长度不能小于6位`);
                        }
                        return Promise.resolve();
                    }
                }]
            },
        ] : []),
        {
            title: lang?.role,
            type: "select",
            field: "RoleId",
            style: { width: 200 },
            options: roleOptions || [],
            rules: [{
                required: true,
                message: `${langCommon?.pleaseSelect} ${lang?.role}`
            }]
        },
        {
            title: '管理员类型',
            type: "select",
            field: "Type",
            style: { width: 200 },
            options: [
                { id: 1, name: '普通管理员' },
                { id: 10, name: '超级管理员' }
            ],
            rules: [{
                required: true,
                message: `${langCommon?.pleaseSelect} 管理员类型`
            }]
        },
        {
            title: langCommon?.status,
            type: "select",
            field: "Status",
            style: { width: 200 },
            options: [
                { id: 1, name: langCommon?.enabled },
                { id: 2, name: langCommon?.disable }
            ],
            rules: [{
                required: true,
                message: `${langCommon?.pleaseSelect} ${langCommon?.status}`
            }]
        },
    ];
}
